import React, { Component } from 'react';

export default class ActionsTotalTrips extends Component {
  onclickEvent = (data) => {
    this.props.context.componentParent.handleActionCellChange(data);
  };

  render() {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
        onClick={() => this.onclickEvent(this.props.data)}
      >
        <div
          className="form-group"
          style={{
            padding: '2px 10px',
            backgroundColor: '#e6f0ff',
            borderRadius: '9999px',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#1e40af',
            fontWeight: 'bold',
            fontSize: '14px',
            minWidth: '24px',
            height: '24px',
          }}
        >
          <b>{`${this.props.value}`}</b>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CellRenderer/ActionsTotalTripsCell.jsx